export default "__VITE_ASSET__2oJggz4h__"